// Valuation Builder screen (Screen 3, MAIN) — PSD §10.2. Stepper wizard.

import { Hammer } from 'lucide-react';
import { useStore, useBuilderStep, useActiveValuation } from '../store/selectors';
import { Stepper } from '../components/builder/Stepper';
import { SetupDatesStep } from '../components/builder/SetupDatesStep';
import { CapTableSelectStep } from '../components/builder/CapTableSelectStep';
import { EquityValueAnchorStep } from '../components/builder/EquityValueAnchorStep';
import { MethodologyStep } from '../components/builder/MethodologyStep';
import { AssumptionsStep } from '../components/builder/AssumptionsStep';
import { DiscountsStep } from '../components/builder/DiscountsStep';
import { RunStep } from '../components/builder/RunStep';
import { EmptyState } from '../components/common/EmptyState';

export function ValuationBuilder() {
  const { currentStep } = useBuilderStep();
  const active = useActiveValuation();
  const advanceStep = useStore((s) => s.advanceStep);
  const gotoStep = useStore((s) => s.gotoStep);
  const navigate = useStore((s) => s.navigate);

  return (
    <div>
      <h1 className="screen-title">Valuation Builder</h1>
      {!active ? (
        <EmptyState
          icon={<Hammer size={32} strokeWidth={1.5} />}
          message="No active valuation."
          hint="The builder walks your cap table, equity-value anchor, methodology, and discounts step by step. Pick or create a valuation on the Dashboard first."
          action={
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => navigate('dashboard')}
            >
              Go to Dashboard
            </button>
          }
        />
      ) : (
        <div className="builder-layout">
          <Stepper />
          <div>
            {currentStep === 1 && <SetupDatesStep />}
            {currentStep === 2 && <CapTableSelectStep />}
            {currentStep === 3 && <EquityValueAnchorStep />}
            {currentStep === 4 && <MethodologyStep />}
            {currentStep === 5 && <AssumptionsStep />}
            {currentStep === 6 && <DiscountsStep />}
            {currentStep === 7 && <RunStep />}
            <div className="header-row mt-4">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => gotoStep(currentStep - 1)}
                disabled={currentStep <= 1}
              >
                ← Back
              </button>
              {currentStep < 7 && (
                <button type="button" className="btn btn-primary" onClick={advanceStep}>
                  Next →
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
